module.exports = __webpack_public_path__ + "static/media/logo-small.982c1b73.svg";